import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import utils from 'utils';
import Table, { TableColumn } from 'components/Table';
import Modal from 'components/Modal';
import styled from 'styled-components/macro';
import { actionType, modalActionType } from 'utils/constants';
import { CommonButton } from 'components/Buttons';
import actions from 'state/actions';
import services from 'services';
import selectors from 'state/selectors';

const Section = styled.div`
  margin-bottom: 20px;
`;

const Description = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Glossary = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const modalProps = useSelector(selectors.modal.getModalProps);
  const manuals = modalProps.manuals ?? [];

  const handlePreview = async (row: any) => {
    const { data } = await services.downloadManual(row.section, row.item);
    dispatch(
      actions.modal.openModal(modalActionType.documents.GLOSSARY_PREVIEW, {
        description: row.description,
        documentImage: data,
        manuals,
      }),
    );
  };

  const columns: TableColumn[] = [
    {
      accessor: 'description',
      Header: t('file_name'),
      width: 429,
      filterType: 'free',
      Cell: ({ value, row }: { value: any; row: any }) => {
        return <Description onClick={() => handlePreview(row.original)}>{value}</Description>;
      },
    },
    {
      accessor: 'icon',
      Header: '',
      Cell: ({ row }: { value: any; row: any }) => {
        return (
          <CommonButton
            id="download-file"
            tooltip={t('pdf')}
            customIcon="download"
            scope="tertiary"
            action={async () => {
              const { data } = await services.downloadManual(row.original.section, row.original.item);
              utils.file.downloadFileFromBase64Source(row.original.description, data, 'application/pdf', 'pdf');
            }}
          />
        );
      },
      width: 74,
      filterType: 'none',
    },
  ];

  return (
    <>
      <Modal.Header title={t(actionType.GLOSSARY)} subtitle={t('here_find_list_documents')} />
      <Modal.Content>
        <Section>
          <Table id="glossary" columns={columns} rows={manuals} hasSort hasExport={false} hasFilter hasToolbar />
        </Section>
      </Modal.Content>
      <Modal.Footer closeButtonText={t('close')} withConfirmButton={false} />
    </>
  );
};

export default Glossary;
